<div
    class="d-flex w-100 h-100"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="d-flex w-100 pulse-rank"
        variant="colored"
        [collapsable]="false"
        (collapsedChange)="_collapsed = $event"
    >
        <cmps-container-header
            [separator]="false"
            [headerColour]="_widget?.headerColour"
            [textColour]="_widget?.headerTextColour"
        >
            {{ _widget.name }}
        </cmps-container-header>
        <cmps-container-content class="h-100">
            <div
                *ngIf="_ranks?.length === 0"
                class="no-data h-100 d-flex align-items-center"
            >
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="w-100"
                *ngIf="_ranks?.length !== 0"
            >
                <div
                    class="sc-widget-content-row"
                    *ngFor="let rank of _ranks"
                >
                    <div class="sc-widget-grid-title text-left">
                        {{ rank.rankName }}
                    </div>
                    <div class="sc-widget-grid-value">
                        {{ rank.rankResultScorecardPeriod }}/{{
                            rank.totalPositionsScorecardPeriod
                        }}
                    </div>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
